import React from 'react';

import PropTypes from 'prop-types';
import Container from './Container';
import { BalanceTransferRolloverProvider } from './Context';

const BalanceTransferRolloverComponent = ({ tabDataRelationship }) => {
  return (
    <BalanceTransferRolloverProvider relationship={tabDataRelationship}>
      <Container />
    </BalanceTransferRolloverProvider>
  );
};

BalanceTransferRolloverComponent.propTypes = {
  tabDataRelationship: PropTypes.object.isRequired,
};

export default BalanceTransferRolloverComponent;
